
const Toast = require('react-toast-mobile');
import config from '../server/config';

const upload = async (e: any, showDownloadTips?: boolean, project?: string, data?: object) => {
    const file = e.target.files[0];
    const formdata = new FormData();
    formdata.append('file', file, file.name);
    if (data) {
        for(let item in data) {
            formdata.append(item, data[item])
        }
    }
    Toast.T.loading('图片上传中');
    try {
        let url = `${config.API}image/upload/crmAnnex`;
        if (project === 'store') {
            url = `${config.API}file/uploadMulti`;
            formdata.append('rootPath', 'wiseshop');
            formdata.append('ratio', '50x0,100x0,200x0,400x0,750x0,1500x0');
        } else if (project === 'ylk') {
            url = `${config.ULKAPI}api/web/index.php?r=image/upload`;
            formdata.delete('file');
            formdata.append('fileType', 'jpg|jpeg|png');
            formdata.append('path', 'productImage');
            formdata.append('fileSize', '2');
            formdata.append('upfile', file, file.name);
        } else if (project === 'cms') { 
            url = `${config.API}image/upload/picture`;
        }
        const r: any = await fetch(url, {
            body: formdata,
            credentials: 'include',
            method: 'POST',
            mode: 'cors'
        }).then(response => response.json());
        Toast.T.loaded();
        if(showDownloadTips) {
            Toast.T.loading('图片下载中');
        }
        // 如果没有登录
        if(r.code === 100) {
            window.location.replace('/mobile/uc/build/login')
            return {};
        }
        else if(r.code === 0){
            Toast.T.notify(r.message);
            return {};
        } else {
            return r;
        }
    } catch(err) {
        console.log(err);
        return {};
    }
}

export default upload;

export const uploadFile = async (e: any, project?: string, data?: object) => {
    const file = e.target.files[0];
    const formdata = new FormData();
    formdata.append('file', file, file.name);
    formdata.append('rootPath', '/user/ibuychem/m');
    if (data) {
        for(let item in data) {
            formdata.append(item, data[item])
        }
    }
    Toast.T.loading('文件上传中');
    try {
        let url = `${config.API}file/upload`;
        if (project === 'ylk') { 
            url = `${config.ULKAPI}api/web/index.php?r=image/upload`;
            formdata.delete('file');
            formdata.delete('rootPath');
            formdata.append('fileType', 'pdf');
            formdata.append('path', 'productFile');
            formdata.append('fileSize', '50');
            formdata.append('upfile', file, file.name);
            formdata.append('type', 'pdf');
        }
    const r: any = await fetch(url, {
        body: formdata,
        credentials: 'include',
        method: 'POST',
        mode: 'cors'
    }).then(response => response.json());
    Toast.T.loaded();
    // 如果没有登录
    if(r.code === 100) {
        window.location.replace('/mobile/uc/build/login')
        return {};
    }
    else if(r.code === 0){
        Toast.T.notify(r.message);
        return {};
    } else {
        return r;
    }
    } catch(err) {
        console.log(err);
        return {};
    }
}

// php分片上传
export const uploadVideoByPHP = async (file: any) => {
    const formdata = new FormData();
    formdata.append('avatar_file', file, file.name);
    return await fetch(`${config.MALLAPI}api/shop/goods/upload-video`, {
        body: formdata,
        credentials: 'include',
        method: 'POST',
        mode: 'cors'
    }).then(response => response.json());
}

function getChunks(file: any, chunkSize: number) {
    const chunks = [];
  let start = 0;
  let end = chunkSize;

  while (start < file.size) {
    chunks.push(file.slice(start, end));
    start = end;
    end = start + chunkSize;
  }
  return chunks
}
async function uploadVideoChunk(file: any, chunks: number, chunk: number, name: string) {
    const formdata = new FormData();
    formdata.append('avatar_file', file, name);
    formdata.append('filename', name);
    formdata.append('chunks', `${chunks}`);
    formdata.append('chunk', `${chunk}`);
    return await fetch(`${config.MALLAPI}api/shop/goods/upload-video2`, {
        body: formdata,
        credentials: 'include',
        method: 'POST',
        mode: 'cors'
    }).then(response => response.json());
}
export const uploadVideoMultiChunks = async (file: any) => {
    const chunks = getChunks(file, 1024 * 1024 * 10)
    const chunksLen = chunks.length
    for (let i = 0; i < chunksLen; i++) {
        await uploadVideoChunk(chunks[i], chunksLen, i, file.name); // 执行异步操作
    }
    const formData = new URLSearchParams();
    formData.append('act', 'combine');
    formData.append('chunks', `${chunksLen}`);
    formData.append('filename', `${file.name}`);
    return await fetch(`${config.MALLAPI}api/shop/goods/upload-video2`, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString(),
        credentials: 'include',
        method: 'POST',
        mode: 'cors'
    }).then(response => response.json());
}
